import { render } from "./MiniTabs.vue?vue&type=template&id=0d839adc"
import script from "./MiniTabs.vue?vue&type=script&lang=js"
export * from "./MiniTabs.vue?vue&type=script&lang=js"

import "./MiniTabs.vue?vue&type=style&index=0&id=0d839adc&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__